import { useInquiryModal } from '@/components/inquiry/InquiryModal';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE, sectionVariants } from './constants';

export default function ClosingInterstitial() {
    const shouldReduceMotion = useReducedMotion();
    const { openInquiry } = useInquiryModal();
    const ease = EASE as unknown as [number, number, number, number];

    return (
        <motion.section
            className="bg-[#0b2222] py-28 lg:py-36"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-80px' }}
            variants={shouldReduceMotion ? undefined : sectionVariants}
        >
            <div className="lux-space-px">
                <div className="mx-auto flex max-w-4xl flex-col items-center text-center">
                    <motion.blockquote
                        className="lux-didot text-[#F5F5F5]"
                        style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)', lineHeight: 1.15 }}
                        variants={
                            shouldReduceMotion
                                ? undefined
                                : { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease } } }
                        }
                    >
                        Every journey begins with a single conversation.
                    </motion.blockquote>
                    <motion.p
                        className="lux-caps lux-caps-sm mt-6 text-[#F5F5F5]/40"
                        variants={
                            shouldReduceMotion
                                ? undefined
                                : {
                                      hidden: { opacity: 0 },
                                      visible: { opacity: 1, transition: { duration: 0.7, delay: 0.3, ease } },
                                  }
                        }
                    >
                        Don&rsquo;t worry, it can be through text.
                    </motion.p>
                    <motion.div
                        className="mt-10"
                        variants={
                            shouldReduceMotion
                                ? undefined
                                : { hidden: { opacity: 0, y: 12 }, visible: { opacity: 1, y: 0, transition: { duration: 0.7, delay: 0.5, ease } } }
                        }
                    >
                        <button
                            type="button"
                            onClick={() => openInquiry({ source: 'journal_landing', page_url: window.location.href })}
                            className="lux-caps lux-caps-sm inline-flex h-12 cursor-pointer items-center justify-center rounded-sm border border-[#F5F5F5]/25 px-10 text-[#F5F5F5] transition-all duration-500 hover:border-[#F5F5F5]/50 hover:bg-[#F5F5F5]/5"
                        >
                            Let&rsquo;s Chat
                        </button>
                    </motion.div>
                </div>
            </div>
        </motion.section>
    );
}
